import './pages.css';
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <div className="page home">
            {/* Introduction Section */}
            <section className="intro-section">
                <div className="intro-content">
                    <h1>Welcome to AbELab</h1>
                    <p className="intro-text">
                        Your trusted partner in premium dental laboratory services. We combine cutting-edge
                        digital technology with traditional craftsmanship to deliver exceptional results for
                        every case.
                    </p>
                    <Link to="/contacts" className="btn-primary">Contact Us</Link>
                </div>
                <div className="background">
                    <img src="/images/background.jpg" alt="" />
                </div>
            </section>

            {/* Hero Section with Video */}
            <section className="hero-section">
                <h1>Discover the Benefits of an Ultimate Partnership</h1>

                <div className="video-container">
                    <iframe
                        width="100%"
                        height="500"
                        src="https://www.youtube.com/embed/oItBeCu0TOQ?si=i-Gkzs0MIjv-wkmp"
                        title="AbELab Introduction"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>

                <div className="hero-description">
                    <p>
                        AbELab is a full-service dental lab located in the Flushing neighborhood of Queens, New York.
                        As a fully digitally ready laboratory, we eagerly embrace the newest innovations, processes, and products.
                        Our goal is to provide clinicians with high-quality restorations and continuing education that can take any
                        practice into the digital era. Our expert team of technicians utilize the latest technology to fabricate
                        exceptional products that provide superior precision, fit, esthetics, and function. Streamline your workflow
                        and provide the best for every patient when you choose AbELab as your dental laboratory partner.
                    </p>
                </div>
            </section>

            {/* Digital Excellence Section */}
            <section className="digital-excellence-section">
                <div className="content-wrapper">
                    <div className="text-content">
                        <h2>Digital Excellence for Every Case</h2>
                        <p className="section-intro">
                            As a digital leader, AbELab has situated itself as a resource for clinicians who are interested
                            in innovating their practice to meet the industry's latest advancements. We provide assistance to
                            every practice irrespective of where they are in the digital integration process.
                        </p>
                        <ul className="benefits-list">
                            <li>Digital Efficiency and Streamlined Cases</li>
                            <li>Improved Patient Satisfaction</li>
                            <li>Accepts Digital Scans from All Major Intraoral Scanners</li>
                            <li>Extreme Precision, Fit, Function, and Esthetics</li>
                            <li>Start to Finish Digital Integration Assistance</li>
                            <li>Unbiased Partnership and Support for Every Scanner</li>
                        </ul>
                    </div>
                    <div className="image-content">
                        <img
                            src="https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=600&h=400&fit=crop"
                            alt="Digital Dental Technology"
                        />
                    </div>
                </div>
            </section>

            {/* Scanner Logos Carousel Section */}
            <section className="scanners-section">
                <h2>We Accept Digital Impressions from Most Major Intraoral Scanners</h2>
                <div className="carousel-container">
                    <div className="carousel-track">
                        <div className="scanner-logo">
                            <img src="/images/scanners/midmark.png" alt="Midmark" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/CEREC.webp" alt="CEREC" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/3shape.png" alt="3Shape" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/carestream.png" alt="Carestream Dental" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/planmeca.png" alt="Planmeca Emerald" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/iTero.png" alt="iTero" />
                        </div>
                        {/* Duplicate logos for seamless loop */}
                        <div className="scanner-logo">
                            <img src="/images/scanners/midmark.png" alt="Midmark" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/CEREC.webp" alt="CEREC" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/3shape.png" alt="3Shape" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/carestream.png" alt="Carestream Dental" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/planmeca.png" alt="Planmeca Emerald" />
                        </div>
                        <div className="scanner-logo">
                            <img src="/images/scanners/iTero.png" alt="iTero" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Traditional Experts Section */}
            <section className="traditional-section">
                <div className="content-wrapper reverse">
                    <div className="image-content">
                        <img
                            src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=600&h=400&fit=crop"
                            alt="Traditional Dental Laboratory"
                        />
                    </div>
                    <div className="text-content">
                        <h2>Your Traditional Experts</h2>
                        <p className="section-intro">
                            AbELab is staffed by highly skilled technicians who ensure high-quality restorations for every case,
                            whether they are based off traditional or digital impressions. Our techs are experienced with traditional
                            impressions, fabricated processes, and restorations, including porcelain-fused-to-metal and layered porcelain.
                        </p>
                        <ul className="benefits-list">
                            <li>Local Pick-Up and Delivery</li>
                            <li>Easily Generate Shipping Labels</li>
                            <li>Optimized Online Case Submission Process</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Testimonials Section */}
            <section className="testimonials-section">
                <h2>Success Stories from Our Clients</h2>
                <div className="testimonials-grid">
                    <div className="testimonial-card">
                        <div className="quote-icon">"</div>
                        <p className="testimonial-text">
                            After switching to AbELab, my team and I have been able to cut down on the hassle for the
                            majority of our cases. I've been very impressed by every restoration I receive back.
                        </p>
                        <p className="testimonial-author">- Dr. D Cole, DDS</p>
                    </div>

                    <div className="testimonial-card">
                        <div className="quote-icon">"</div>
                        <p className="testimonial-text">
                            My practice uses our scanner for nearly every case. It has been amazing to send our cases to
                            a digital lab that prioritizes the digital workflow as much as we do.
                        </p>
                        <p className="testimonial-author">- Dr. Jim Norton, DDS</p>
                    </div>

                    <div className="testimonial-card">
                        <div className="quote-icon">"</div>
                        <p className="testimonial-text">
                            I have used them for the majority of my cases. Every restoration we receive fulfills my expectations
                            and gives the results that my patient wanted. Every case is returned on time.
                        </p>
                        <p className="testimonial-author">- Dr. Kimberley Douglas, DDS</p>
                    </div>
                </div>
            </section>

            {/* Call to Action Section */}
            <section className="cta-section">
                <h2>Ready to Partner with AbELab?</h2>
                <p>Experience the difference of working with a fully digital dental laboratory</p>
                <div className="cta-buttons">
                    <button className="btn-primary">Get Started Today</button>
                    <Link to="/contacts" className="btn-secondary">Contact Us</Link>
                </div>
            </section>
        </div>
    );
};

export default Home;